import styles from "./skills.module.css";

const OneSkill = (props) => {  
  // const styleClass = props.className + " " + styles.icons_all;
  return (
    <div className={styles.icons_all}> 
      <span
        className={props.className+" iconify"} 
        data-icon={props.skill}
        data-inline="false"
        data-width="90px" 
        data-height="90px"
      ></span><span>{props.sName}</span>     
    </div>
  );
};

export default OneSkill;
